import React, { useState } from "react";
import { CaretDownFilled, UserOutlined } from "@ant-design/icons";
import { Menu, Avatar, Dropdown } from "antd";
import { useGlobalTeam } from "./useGlobalTeam";
import { useSession } from "next-auth/react";
import { trpc } from "@utils";
import { PopupCard } from "@ui";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export const TeamSelector = () => {
    const { data } = useSession();

    const [open, setOpen] = useState(false);

    const { isError, data: userTeams } = trpc.team.list.useQuery(undefined, {
        enabled: !data?.impersonatedUser?.ro_id,
    });

    const { data: impersonatedTeams } =
        trpc.admin.listImpersonatedTeams.useQuery(undefined, {
            enabled: !!data?.impersonatedUser?.ro_id,
        });

    const orgs =
        (data?.impersonatedUser?.ro_id ? impersonatedTeams : userTeams) ?? [];
    const { selectedTeam, setSelectedTeamId } = useGlobalTeam();

    if (isError) {
        return (
            <PopupCard
                className="z-50"
                sideValue="left"
                trigger={
                    <ExclamationTriangleIcon className="size-5 text-primary-yellow" />
                }
            >
                There was an error loading your teams. Please refresh the page.
            </PopupCard>
        );
    }

    const menu = (
        <Menu>
            {orgs.map((org) => (
                <Menu.Item
                    key={org.id}
                    onClick={() => setSelectedTeamId({ newOrgId: org.id })}
                    disabled={selectedTeam?.organizationId === org.id}
                >
                    <div className="flex h-[40px] w-[200px] items-center">
                        <Avatar
                            icon={<UserOutlined />}
                            style={{ marginRight: 8 }}
                            src={org?.branding?.logoUrl}
                        />
                        <span>{org.displayName}</span>
                    </div>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown
            overlay={menu}
            trigger={["click"]}
            onOpenChange={(e) => setOpen(e)}
        >
            <div className="cursor-pointer">
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: 8,
                    }}
                >
                    <Avatar
                        icon={<UserOutlined />}
                        src={selectedTeam?.branding?.logoUrl}
                    />
                    <div style={{ marginRight: 8 }} />
                    <span className="pr-2">{selectedTeam?.displayName}</span>
                    <CaretDownFilled
                        className={`${!open ? "-rotate-90" : "rotate-0"} size-4 transition-all`}
                    />
                </div>
            </div>
        </Dropdown>
    );
};
